var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav-list',{attrs:{"title":_vm.$t('system.navigation.counselingEvents')}},[_c('nav-list-item',[_c('router-link',{attrs:{"to":{ name: 'counselingEvents' }}},[_vm._v(_vm._s(_vm.$t('system.navigation.currentCounselingEvents')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }